import { createFileRoute } from "@tanstack/react-router";

import { BASE_COLOR } from "~/components/feature/results/components/ResultsCost";
import { DetailPage } from "~/components/feature/shared/components/DetailPage";

export const Route = createFileRoute(
  "/_app/dashboard/results/cost/$category/detail",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { category } = Route.useParams();
  return (
    <DetailPage
      tab="cost"
      category={category}
      targetMetric="results"
      baseColor={BASE_COLOR}
    />
  );
}
